import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../internal';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      clipPath: "url(#IconDraw24a)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.496.04A3.001 3.001 0 0 0 7 3v11.234l-2.43-1.458a2.946 2.946 0 0 0-3.599 4.61L7.586 24h13.272l1.7-11.051a4 4 0 0 0-3.115-4.52L13 7.05V3.107C13 1.695 12.034.291 10.496.04ZM9 3a1 1 0 0 1 1.175-.985c.43.07.825.511.825 1.092v5.559l8.024 1.719a2 2 0 0 1 1.557 2.26L19.142 22H8.414l-6.028-6.028a.946.946 0 0 1 1.156-1.48L9 17.765V3Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M23.268 3.36c-1.42-1.704-3.25-2.537-4.68-2.946a11.263 11.263 0 0 0-1.812-.36A9.016 9.016 0 0 0 16.023 0h-.021S16 0 16 1V0h-1v2h1.021l.104.005c.096.005.242.015.427.036.37.042.893.126 1.486.296 1.193.34 2.614 1.008 3.694 2.303l.64.769 1.536-1.28-.64-.77Z"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "IconDraw24a",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        })
      })
    })]
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var IconDraw24 = createIcon(IconComponent);